<template>
  <div>
    <v-tooltip bottom :disabled="hasDateFilter">
      <template v-slot:activator="{ on, attrs }">
        <span v-on="on" v-bind="attrs">
          <v-btn
            :disabled="disabled || !hasDateFilter"
            color="primary"
            :loading="loading"
            @click="getExcel"
            text
            class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
          >
            <v-icon left size="16">fas fa-file-excel</v-icon>
            Exportar
          </v-btn>
        </span>
      </template>
      <span>Selecciona al menos una fecha para exportar</span>
    </v-tooltip>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import { excelRelbaseSyncReport } from '@/api/relbase'
import moment from 'moment'

export default {
  name: "ExportRelbaseSyncReport",
  props: {
    filter: { type: Object, default: () => ({}) },
    options: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    search: { type: String, default: "" }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    hasDateFilter() {
      return !!(this.filter.created_after || this.filter.created_before)
    }
  },
  methods: {
    async getExcel() {
      this.loading = true

      const { sortBy, sortDesc } = this.options
      const sortField = (sortBy && sortBy.length) ? sortBy[0] : 'id'
      const ordering = (sortDesc && sortDesc[0]) ? sortField : `-${sortField}`

      const params = new URLSearchParams({
        created_at_after: this.filter.created_after || '',
        created_at_before: this.filter.created_before || '',
        customer: this.filter.customer || '',
        seller: this.filter.seller || '',
        search: this.search || '',
        ordering: ordering
      })

      if (this.filter.is_synced !== null && this.filter.is_synced !== undefined) {
        params.append('is_synced', this.filter.is_synced)
      }

      await excelRelbaseSyncReport(params.toString())
        .then((response) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(response);
          link.setAttribute('download', `facturacion_ot_relbase_${moment().format('DD-MM-YYYY_HHmm')}.xlsx`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          notifications.showSuccess('Reporte generado exitosamente')
        })
        .catch(() => {
          notifications.showError('Error al exportar reporte')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.h-44 { height: 44px !important; }
.tracking-widest { letter-spacing: 1.5px; }
</style>
